import "core-js/modules/es.function.name.js";
export default {
  name: 'PzOfertaUpSolicitudCba',
  inject: ['myForm'],
  mounted: function mounted() {
    // this.$store.dispatch('loader/down', {trigger: this.$options.name})
    this.$store.dispatch('loader/up', {
      trigger: this.$options.name
    });
  }
};